function getFocusableElements(container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }
  
  const trapFocusHandlers = {};
  
  function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];
  
    removeTrapFocus();
  
    trapFocusHandlers.focusin = (event) => {
      if (
        event.target !== container &&
        event.target !== last &&
        event.target !== first
      )
        return;
  
      document.addEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.focusout = function () {
      document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };
  
    trapFocusHandlers.keydown = function (event) {
      if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
      // On the last focusable element and tab forward, focus the first element.
      if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
      }
  
      //  On the first focusable element and tab backward, focus the last element.
      if (
        (event.target === container || event.target === first) &&
        event.shiftKey
      ) {
        event.preventDefault();
        last.focus();
      }
    };
  
    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);
  
    elementToFocus.focus();
  }
  
  // Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
  try {
    document.querySelector(":focus-visible");
  } catch {
    focusVisiblePolyfill();
  }
  
  function focusVisiblePolyfill() {
    const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
    let currentFocusedElement = null;
    let mouseClick = null;
  
    window.addEventListener('keydown', (event) => {
      if (navKeys.includes(event.code.toUpperCase())) {
        mouseClick = false;
      }
    });
  
    window.addEventListener('mousedown', (event) => {
      mouseClick = true;
    });
  
    window.addEventListener('focus', () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
  
      if (mouseClick) return;
  
      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
  
    }, true);
  }
  
  /**
   * make sure all external links in header and footer open in new window/tab
   */
  function openExternalGlobalLinksInNewWindow() {
    const linkSelector = '#menu-drawer a, header.header nav a, footer.footer a';
  
    Array.from(document.querySelectorAll(linkSelector)).forEach((link) => {
      const href = link.getAttribute('href');
      const isExternalLink = href && href.indexOf(window.location.host) === -1 && href.slice(0, 1) !== '/';
  
      if (!isExternalLink) return;
  
      if (!href.includes("#language_form")) { link.setAttribute('target', '_blank'); }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openExternalGlobalLinksInNewWindow);
  } else {
    openExternalGlobalLinksInNewWindow();
  }
  
  function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
      if (model.modelViewerUI) modelViewerUI.pause();
    });
  }
  
  function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  
    if (elementToFocus) elementToFocus.focus();
  }
  
  function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
  
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
  
    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.focus();
  }
  
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true });
  
      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;
  
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
  
      if (previousValue !== this.input.value) {
        this.input.dispatchEvent(this.changeEvent);
        this.dispatchEvent(new CustomEvent('change:quantity', {
          bubbles: true,
          detail: {
            quantity: this.input.value
          }
        }));
      }
    }
  }
  
  customElements.define('quantity-input', QuantityInput);
  
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
  
  const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
  
    for (const key of formData.keys()) {
      const regex = /(?:^(properties\[))(.*?)(?:\]$)/;
  
      if (regex.test(key)) {
        obj.properties = obj.properties || {};
        obj.properties[regex.exec(key)[2]] = formData.get(key);
      } else {
        obj[key] = formData.get(key);
      }
    }
  
    return JSON.stringify(obj);
  };
  
  function fetchConfig(type = 'json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }
  
  /*
   * Shopify Common JS
   *
   */
  if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
  }
  
  Shopify.bind = function (fn, scope) {
    return function () {
      return fn.apply(scope, arguments);
    }
  };
  
  Shopify.setSelectorByValue = function (selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
      var option = selector.options[i];
      if (value == option.value || value == option.innerHTML) {
        selector.selectedIndex = i;
        return i;
      }
    }
  };
  
  Shopify.addListener = function (target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
  };
  
  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};
  
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
  
    for (var key in params) {
      var hiddenField = document.createElement("input");
      hiddenField.setAttribute("type", "hidden");
      hiddenField.setAttribute("name", key);
      hiddenField.setAttribute("value", params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };
  
  Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  
    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  
    this.initCountry();
    this.initProvince();
  };
  
  Shopify.CountryProvinceSelector.prototype = {
    initCountry: function () {
      var value = this.countryEl.getAttribute('data-default');
      Shopify.setSelectorByValue(this.countryEl, value);
      this.countryHandler();
    },
  
    initProvince: function () {
      var value = this.provinceEl.getAttribute('data-default');
      if (value && this.provinceEl.options.length > 0) {
        Shopify.setSelectorByValue(this.provinceEl, value);
      }
    },
  
    countryHandler: function (e) {
      var opt = this.countryEl.options[this.countryEl.selectedIndex];
      var raw = opt.getAttribute('data-provinces');
      var provinces = JSON.parse(raw);
  
      this.clearOptions(this.provinceEl);
      if (provinces && provinces.length == 0) {
        this.provinceContainer.style.display = 'none';
      } else {
        for (var i = 0; i < provinces.length; i++) {
          var opt = document.createElement('option');
          opt.value = provinces[i][0];
          opt.innerHTML = provinces[i][1];
          this.provinceEl.appendChild(opt);
        }
  
        this.provinceContainer.style.display = "";
      }
    },
  
    clearOptions: function (selector) {
      while (selector.firstChild) {
        selector.removeChild(selector.firstChild);
      }
    },
  
    setOptions: function (selector, values) {
      for (var i = 0, count = values.length; i < values.length; i++) {
        var opt = document.createElement('option');
        opt.value = values[i];
        opt.innerHTML = values[i];
        selector.appendChild(opt);
      }
    }
  };
  
  class MenuDrawer extends HTMLElement {
    constructor() {
      super();
  
      this.mainDetailsToggle = this.querySelector('details');
      const summaryElements = this.querySelectorAll('summary');
      this.addAccessibilityAttributes(summaryElements);
  
      if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.bindEvents();
    }
  
    bindEvents() {
      this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.querySelectorAll('button:not(.localization-form__select)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
  
    addAccessibilityAttributes(summaryElements) {
      summaryElements.forEach(element => {
        element.setAttribute('role', 'button');
        element.setAttribute('aria-expanded', false);
        element.setAttribute('aria-controls', element.nextElementSibling.id);
      });
    }
  
    onKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      const openDetailsElement = event.target.closest('details[open]');
      if (!openDetailsElement) return;
  
      openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }
  
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const isOpen = detailsElement.hasAttribute('open');
  
      if (detailsElement === this.mainDetailsToggle) {
        if (isOpen) event.preventDefault();
        isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
      } else {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
  
        setTimeout(() => {
          detailsElement.classList.add('menu-opening');
        });
      }
    }
  
    openMenuDrawer(summaryElement) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  
    closeMenuDrawer(event, elementToFocus = false) {
      if (event !== undefined) {
        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
          details.removeAttribute('open');
          details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);
      }
    }
  
    onFocusOut(event) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  
    onCloseButtonClick(event) {
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
  
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      removeTrapFocus();
      this.closeAnimation(detailsElement);
    }
  
    closeAnimation(detailsElement) {
      let animationStart;
  
      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }
  
        const elapsedTime = time - animationStart;
  
        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
          if (detailsElement.closest('details[open]')) {
            trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
          }
        }
      }
  
      window.requestAnimationFrame(handleAnimation);
    }
  }
  
  customElements.define('menu-drawer', MenuDrawer);
  
  class HeaderDrawer extends MenuDrawer {
    constructor() {
      super();
    }
  
    openMenuDrawer(summaryElement) {
      this.header = this.header || document.getElementById('shopify-section-header') || document.getElementById('shopify-section-header-ed-sheeran');
      this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
  
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
  
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  }
  
  customElements.define('header-drawer', HeaderDrawer);
  
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelector('[id^="ModalClose-"]').addEventListener(
        'click',
        this.hide.bind(this)
      );
      this.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.hide();
      });
      if (this.classList.contains('media-modal')) {
        this.addEventListener('pointerup', (event) => {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
        });
      } else {
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });
      }
    }
  
    show(opener) {
      this.openedBy = opener;
      const popup = this.querySelector('.template-popup');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      if (popup) popup.loadContent();
      trapFocus(this, this.querySelector('[role="dialog"]'));
    }
  
    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      removeTrapFocus(this.openedBy);
      window.pauseAllMedia();
    }
  }
  customElements.define('modal-dialog', ModalDialog);
  
  class ModalOpener extends HTMLElement {
    constructor() {
      super();
  
      const button = this.querySelector('button');
  
      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (modal) modal.show(button);
      });
    }
  }
  customElements.define('modal-opener', ModalOpener);
  
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    loadContent() {
      window.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
      }
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);
  
  class SliderComponent extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;
  
      this.initPages();
      const resizeObserver = new ResizeObserver(entries => this.initPages());
      resizeObserver.observe(this.slider);
  
      this.slider.addEventListener('scroll', this.update.bind(this));
      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }
  
    initPages() {
      this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
      if (this.sliderItemsToShow.length < 2) return;
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
      this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
      this.update();
    }
  
    resetPages() {
      this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
      this.initPages();
    }
  
    update() {
      const previousPage = this.currentPage;
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.totalPages;
      }
  
      if (this.currentPage != previousPage) {
        this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }}));
      }
  
      if (this.enableSliderLooping) return;
  
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
  
      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  
    isSlideVisible(element, offset = 0) {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  
    onButtonClick(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  }
  
  customElements.define('slider-component', SliderComponent);
  
  class SlideshowComponent extends SliderComponent {
    constructor() {
      super();
      this.sliderControlWrapper = this.querySelector('.slider-buttons');
      this.enableSliderLooping = true;
  
      if (!this.sliderControlWrapper) return;
  
      this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
      if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  
      this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
      this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
      this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
      this.setSlideVisibility();
  
      if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }
  
    setAutoPlay() {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.autoplaySpeed = this.slider.dataset.speed * 1000;
  
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.addEventListener('mouseover', this.focusInHandling.bind(this));
      this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
      this.addEventListener('focusin', this.focusInHandling.bind(this));
      this.addEventListener('focusout', this.focusOutHandling.bind(this));
  
      this.play();
      this.autoplayButtonIsSetToPlay = true;
    }
  
    onButtonClick(event) {
      super.onButtonClick(event);
      const isFirstSlide = this.currentPage === 1;
      const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
  
      if (!isFirstSlide && !isLastSlide) return;
  
      if (isFirstSlide && event.currentTarget.name === 'previous') {
        this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
      } else if (isLastSlide && event.currentTarget.name === 'next') {
        this.slideScrollPosition = 0;
      }
      this.slider.scrollTo({
        left: this.slideScrollPosition
      });
    }
  
    update() {
      super.update();
      this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
      this.prevButton.removeAttribute('disabled');
  
      if (!this.sliderControlButtons.length) return;
  
      this.sliderControlButtons.forEach(link => {
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });
      this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
      this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }
  
    autoPlayToggle() {
      this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
      this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
      this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }
  
    focusOutHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    }
  
    focusInHandling(event) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    }
  
    play() {
      this.slider.setAttribute('aria-live', 'off');
      clearInterval(this.autoplay);
      this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }
  
    pause() {
      this.slider.setAttribute('aria-live', 'polite');
      clearInterval(this.autoplay);
    }
  
    togglePlayButtonState(pauseAutoplay) {
      if (pauseAutoplay) {
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
      } else {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
      }
    }
  
    autoRotateSlides() {
      const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  
    setSlideVisibility() {
      this.sliderItemsToShow.forEach((item, index) => {
        const button = item.querySelector('a');
        if (index === this.currentPage - 1) {
          if (button) button.removeAttribute('tabindex');
          item.setAttribute('aria-hidden', 'false');
          item.removeAttribute('tabindex');
        } else {
          if (button) button.setAttribute('tabindex', '-1');
          item.setAttribute('aria-hidden', 'true');
          item.setAttribute('tabindex', '-1');
        }
      });
    }
  
    linkToSlide(event) {
      event.preventDefault();
      const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
      this.slider.scrollTo({
        left: slideScrollPosition
      });
    }
  }
  
  customElements.define('slideshow-component', SlideshowComponent);
  
  
  
  window.inventoryValidator = new class InventoryValidator {
    constructor() {
      this.cartContents = {};
      this.getCartContents(true);
      document.addEventListener('cart:updated', this.handleCartUpdated.bind(this));
    }
  
    handleCartUpdated(event) {
      if (event.detail && event.detail.items) {
        this.getCartContents(false, event.detail);
      } else {
        this.getCartContents();
      }
    }
  
    getSellableInventoryForVariant(variant) {
  
      if (!variant.available) return 0;
  
      const trackInventory = variant.inventory_management && variant.inventory_policy === 'deny';
  
      if (!trackInventory) return 10000;
  
      const quantityInCart = this.cartContents[variant.id] ? this.cartContents[variant.id].quantity : 0;
      let quantityAvailable = variant.inventory_quantity - variant.safetyStock - quantityInCart;
  
      quantityAvailable = quantityAvailable < 0 ? 0 : quantityAvailable;
  
      return quantityAvailable;
    }
  
    /**
     * retrieves quantities of each variant in the cart and stores them in an object.
     * merges variants in bundles with individual products and adds their quantities together
     * @param getDataFromPage true for page load only when no async cart updates have been made.
     *    this will allow us to grab the cart contents from a global variable set in theme.liquid
     * @param cart cart object from an async call that already happened. pass this in to prevent unneeded requests
     */
    async getCartContents(getDataFromPage = false, cart = {}) {
      let cartItems = null;
  
      if (cart && cart.items) {
        cartItems = cart.items;
      } else if (getDataFromPage && window.shoppingCart) {
        cartItems = window.shoppingCart.items;
      } else {
        cartItems = await fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
            return data.items;
          });
      }
  
      this.cartContents = {};
  
      // build out the cart quantity object
      for (let i = 0; i < cartItems.length; i++) {
        let bundleLineItems = Object.entries(cartItems[i].properties).filter(([key]) => key.includes('_line_item_data_for_product_'));
        let isBundle = bundleLineItems.length > 0;
  
        if (isBundle) {
          let bundleQuantity = cartItems[i].quantity;
          let bundleItemVariants = Object.fromEntries(Object.entries(cartItems[i].properties).filter(([key]) => key.includes('_bundle_selectedVariantOnProduct_')));
  
          // loop through bundle items and add each variant to cartContents
          bundleLineItems.forEach(lineItem => {
            let productId = lineItem[0].replace('_line_item_data_for_product_', '');
            let variantId = bundleItemVariants[`_bundle_selectedVariantOnProduct_${productId}`];
            let quantityInBundle = JSON.parse(Object.fromEntries(bundleLineItems)[`_line_item_data_for_product_${productId}`])['quantity in bundle'];
  
            this.cartContents[variantId] = this.cartContents[variantId] || { quantity: 0 };
            this.cartContents[variantId].quantity += (bundleQuantity * quantityInBundle);
          });
        } else {
          this.cartContents[cartItems[i].variant_id] = this.cartContents[cartItems[i].variant_id] || { quantity: 0 };
          this.cartContents[cartItems[i].variant_id].quantity += cartItems[i].quantity;
        }
      }
    }
  }();
  
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
      this.updateOptions();
      this.updateMasterId();
      this.renderProductInfo()
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.filterOptionsByAvailability(); // this is new function
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.dispatchEvent(new CustomEvent('change:variant', {
          bubbles: true,
          detail: {
            variant: this.currentVariant
          }
        }));
      }
    }

    filterOptionsByAvailability() {
      const variantData = this.getVariantData();
      const selectedOption1 = this.options[0]; // e.g., Color
      const selectedOption2 = this.options[1]; // e.g., Size
  
      const selectElements = this.querySelectorAll("select");
      const fieldsets = this.querySelectorAll("fieldset");
  
      // -------- Handle Option2 (Size) filtering when Option1 (Color) is selected --------
      if (selectedOption1) {
        if (selectElements.length > 1) {
          const sizeSelect = selectElements[1]; // Size dropdown
          const sizeOptions = Array.from(sizeSelect.options);
  
          sizeOptions.forEach((option) => {
            if (option.value === "") return; // Skip placeholder
  
            const matchingVariant = variantData.find(
              (variant) =>
                variant.option1 === selectedOption1 &&
                variant.option2 === option.value
            );
  
            option.disabled = !matchingVariant || !matchingVariant.available;
          });
        }
  
        if (fieldsets.length > 1) {
          const sizeFieldset = fieldsets[1]; // Size pills
          const radios = sizeFieldset.querySelectorAll('input[type="radio"]');
          const labels = sizeFieldset.querySelectorAll("label");
  
          radios.forEach((radio, index) => {
            const optionValue = radio.value;
  
            const matchingVariant = variantData.find(
              (variant) =>
                variant.option1 === selectedOption1 &&
                variant.option2 === optionValue
            );
  
            radio.disabled = !matchingVariant || !matchingVariant.available;
            labels[index].classList.toggle("disabled", radio.disabled); // Add/remove disabled styling
          });
        }
      }
  
      // -------- Handle Option1 (Color) filtering when Option2 (Size) is selected --------
      if (selectedOption2) {
        if (selectElements.length > 0) {
          const colorSelect = selectElements[0]; // Color dropdown
          const colorOptions = Array.from(colorSelect.options);
  
          colorOptions.forEach((option) => {
            if (option.value === "") return; // Skip placeholder
  
            const matchingVariant = variantData.find(
              (variant) =>
                variant.option1 === option.value &&
                variant.option2 === selectedOption2
            );
  
            option.disabled = !matchingVariant || !matchingVariant.available;
          });
        }
  
        if (fieldsets.length > 0) {
          const colorFieldset = fieldsets[0]; // Color pills
          const radios = colorFieldset.querySelectorAll('input[type="radio"]');
          const labels = colorFieldset.querySelectorAll("label");
  
          radios.forEach((radio, index) => {
            const optionValue = radio.value;
  
            const matchingVariant = variantData.find(
              (variant) =>
                variant.option1 === optionValue &&
                variant.option2 === selectedOption2
            );
  
            radio.disabled = !matchingVariant || !matchingVariant.available;
            labels[index].classList.toggle("disabled", radio.disabled); // Add/remove disabled styling
          });
        }
      }
    }

  
    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }
  
    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      const newMedia = document.querySelector(
        `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
      );
  
      if (!newMedia) return;
      const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
      const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
      const parent = newMedia.parentElement;
      if (parent.firstChild == newMedia) return;
      modalContent.prepend(newMediaModal);
      parent.prepend(newMedia);
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (this.stickyHeader) {
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }
      window.setTimeout(() => { parent.querySelector('li.product__media-item').scrollIntoView({ behavior: "smooth" }); });
    }
  
    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  
    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  
    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability[available]');
      if (!pickUpAvailability) return;
  
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  
    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
  
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  
    renderProductInfo() {
      if (this.constructor.name === 'ProductBundleItem') return
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const id = `price-${this.dataset.section}`;
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(id);
          const source = html.getElementById(id);
          const price = document.getElementById(`price-${this.dataset.section}`);
          const inventory_policy = window[this.dataset.section].variantsById[this.currentVariant.id].inventory_policy;
          const safetyStock = window[this.dataset.section].safetyStock;
          const trackInventory = this.currentVariant.inventory_management && inventory_policy === 'deny';
          const selectedQuantity = parseInt(document.getElementById(`Quantity-${this.dataset.section}`).value || 1, 10);
          let inventory = window[this.dataset.section].variantsById[this.currentVariant.id].inventory_quantity;
          let quantityInCart = 0;
  
          try {
            quantityInCart = inventoryValidator.cartContents[this.currentVariant.id].quantity;
          } catch (error) {
            // fail silently
          }
          inventory -= quantityInCart;
  
          // set to available if
          // 1. inventory is not managed
          // 2. inventory is managed but "continue selling when out of stock" is checked
          // 3. inventory is managed and inventory > safety stock
          let isAvailable = (this.currentVariant.available && !trackInventory)
            || (this.currentVariant.available && trackInventory && inventory > safetyStock && selectedQuantity <= inventory - safetyStock);
  
          if (source && destination) destination.innerHTML = source.innerHTML;
          if (price) price.classList.remove('visibility-hidden');
  
          if (this.dataset.oosForceVariant.includes(this.currentVariant.id) || this.dataset.oosProductForce == 'true') { isAvailable = false; } // Just for out-of-stock-force feature
          this.toggleAddButton(!isAvailable, window.variantStrings.soldOut);
        });
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
  
      if (!addButton) return;
  
      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButtonText.textContent = text;
      // } else {
      //   addButton.removeAttribute('disabled', true);
      //   // addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = 'select options';
      // if (price) price.classList.add('visibility-hidden');
    }
  
    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  
  customElements.define('variant-selects', VariantSelects);
  
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }
  
    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      });
    }
  }
  
  customElements.define('variant-radios', VariantRadios);
  
  class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.variantId = this.dataset.defaultVariantId;
  
      if (this.variantId) {
        this.currentVariant = window[this.dataset.section].variantsById[this.variantId];
      }
  
      this.selectedQuantity = parseInt(document.querySelector(`#shopify-section-${this.dataset.section} quantity-input input`).value, 10);
      this.updateAvailability();
  
      document.addEventListener('cart:updated', this.handleCartUpdated.bind(this));
      this.addEventListener('change:quantity', this.onQuantityChange);
      this.addEventListener('change:variant', this.onVariantChange);
    }
  
    handleCartUpdated() {
      // give cart time to update before validating availability
      setTimeout(this.updateAvailability.bind(this), 2000);
    }
  
    onVariantChange(event) {
      this.variantId = event.detail.variant.id;
      this.currentVariant = window[this.dataset.section].variantsById[event.detail.variant.id];
      this.updateAvailability();
    }
  
    onQuantityChange(event) {
      this.selectedQuantity = parseInt(event.detail.quantity || 1, 10);
      this.updateAvailability();
    }
  
    updateAvailability() {
      const inventory_policy = window[this.dataset.section].variantsById[this.variantId].inventory_policy;
      const safetyStock = window[this.dataset.section].safetyStock;
      const trackInventory = this.currentVariant.inventory_management && inventory_policy === 'deny';
  
      let inventory = window[this.dataset.section].variantsById[this.variantId].inventory_quantity;
      let quantityInCart = 0;
  
      try {
        quantityInCart = inventoryValidator.cartContents[this.currentVariant.id].quantity;
      } catch (error) {
        // fail silently
      }
      inventory -= quantityInCart;
  
      // set to available if
      // 1. inventory is not managed
      // 2. inventory is managed but "continue selling when out of stock" is checked
      // 3. inventory is managed and inventory > safety stock
      let isAvailable = (this.currentVariant.available && !trackInventory)
        || (this.currentVariant.available && trackInventory && inventory > safetyStock && this.selectedQuantity <= inventory - safetyStock);
  
      if (this.dataset.oosForceVariant.includes(this.currentVariant.id) || this.dataset.oosProductForce == 'true') { isAvailable = false; } // Just for out-of-stock-force feature
      this.toggleAddButton(!isAvailable, window.variantStrings.soldOut);
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
  
      if (!addButton) return;
  
      if (disable || this.dataset.oosProductForce == 'true') {
        addButton.setAttribute('disabled', true);
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  }
  
  customElements.define('product-info', ProductInfo);
  
  class ProuctBundleInfo extends HTMLElement {
    constructor() {
      super();
      this.bundleItems = this.querySelectorAll('product-bundle-item');
      this.selectedQuantity = 1; // default to 1 on page load
      document.addEventListener('cart:updated', this.handleCartUpdated.bind(this));
      this.addEventListener('bundle-updated', this.onBundleUpdated);
      this.addEventListener('change:quantity', this.onQuantityChange);
      this.onBundleUpdated()
    }
  
    handleCartUpdated() {
      // give cart time to update before validating availability
      setTimeout(this.onBundleUpdated.bind(this), 2000);
    }
  
    onQuantityChange(event) {
      this.selectedQuantity = parseInt(event.detail.quantity || 1, 10);
      this.onBundleUpdated();
    }
  
    onBundleUpdated() {
      // start with a high number for calculation
      let availableInventory = 1000000;
  
      // loop through each bundleItem to check availability
      // make sure to only check items with tracked inventory
      Array.from(this.bundleItems).filter(item => !!item.currentVariant && !!item.currentVariant.inventory_management).forEach((item) => {
        let itemInventory = item.availableInventory;
        let quantityInCart = 0;
        try {
          quantityInCart = inventoryValidator.cartContents[item.currentVariant.id].quantity;
        } catch (error) {
          // fail silently
        }
        itemInventory -= quantityInCart; 
        if (item.dataset.oosForceVariant.includes(item.currentVariant.id) ) { itemInventory = 0 } // Just for out-of-stock-force feature
  
        // set availableInventory to lowest of all items
        availableInventory = itemInventory < availableInventory ? itemInventory : availableInventory;
      });
  
      this.availableInventory = availableInventory;
      this.available = availableInventory >= this.selectedQuantity;
  
      if (this.dataset.oosProductForce == 'true') { this.available = false; } // Just for out-of-stock-force feature
      // if there is inventory but not enough for selected quantity > 1, use different message
      let oosMessage = !this.available && this.selectedQuantity > 1 && availableInventory >= 1 ? window.variantStrings.unavailable : window.variantStrings.soldOut;
  
      this.toggleAddButton(!this.available, oosMessage);
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
  
      if (!addButton) return;

      // SPMSS-137 ===========================================||
      
      var fieldsets = document.getElementsByTagName('fieldset')
      var fieldsetsArray = [...fieldsets]

      var message

      if (fieldsetsArray.length > 1) {
        message = 'Select Options'
        disable = checkAllFieldsets() 
      }

      // SPMSS-137 ===========================================||
  
      if (disable) {
        addButton.setAttribute('disabled', true);
        if (text) addButtonText.textContent = message || text; // SPMSS-137
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }
  
      if (!modifyClass) return;
    }
  
    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }
  }
  
  customElements.define('product-bundle-info', ProuctBundleInfo);
  
  
  class ProductBundleItem extends VariantSelects {
    constructor() {
      super();
      this.updatedEvent = new Event('bundle-updated', { bubbles: true })
      this.init();
      this.addEventListener('change', this.onVariantChange);
    }
  
    init() {
      this.updateOptions();
      this.updateMasterId();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        this.updateInventory();
        this.dispatchEvent(this.updatedEvent);
      }
    }
  
    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
  
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        this.updateInventory();
        this.dispatchEvent(this.updatedEvent);
      }
    }
  
    updateOptions() {
      const fields = Array.from(this.querySelectorAll('input[type="radio"], select, input.hidden-variant-option'));
  
      this.options = fields.map(field => {
        if (field.type === 'radio') {
          if (field.checked) {
            return field.value;
          }
        } else {
          return field.value;
        }
      }).filter(value => {
        return !!value;
      });
    }
  
    updateVariantInput() {
      const input = this.querySelector(`input[name="properties[_bundle_selectedVariantOnProduct_${this.dataset.productId}]"]`);
      const displayInput = this.querySelector(`input#display-option-${this.dataset.productId}`);
      const preorderText = this.dataset.preOrder ? `(Pre-order Releases on ${this.dataset.preOrder})` : '';
      const defaultVariantText = preorderText || '--'
  
      input.value = this.currentVariant.id;
      displayInput.value = this.dataset.hasOnlyDefaultVariant === 'true' ? defaultVariantText : `${this.currentVariant.title} ${preorderText}`;
    }
  
    /**
     * determine available inventory based on inventory of selected variant (later minus safety stock of product type)
     */
    getAvailableInventory() {
      return this.availableInventory;
    }
  
    updateInventory() {
      // need to check inventory via JS because we cant utilize built-in variant functionality in bundles
      const safetyStock = parseInt(this.dataset.safetyStock, 10);
      const inventory = window[this.dataset.section].variantsById[this.currentVariant.id].inventory_quantity;
      const inventory_policy = window[this.dataset.section].variantsById[this.currentVariant.id].inventory_policy;
      const trackInventory = this.currentVariant.inventory_management && inventory_policy === 'deny';
  
      // set to available if
      // 1. inventory is not managed
      // 2. inventory is managed but "continue selling when out of stock" is checked
      // 3. inventory is managed and inventory > safety stock
      let isAvailable = (this.currentVariant.available && !trackInventory)
        || (this.currentVariant.available && trackInventory && inventory > safetyStock);
  
      // set inventory to 1000 if not tracked. otherwise use actual inventory unless oos
      this.availableInventory = this.currentVariant.available && !trackInventory ? 1000 : isAvailable ? inventory - safetyStock : 0;
  
      if (this.dataset.oosForceVariant.includes(this.currentVariant.id) || this.dataset.oosProductForce == 'true') { this.availableInventory = 0; } // Just for out-of-stock-force feature
    }
  
  }
  
  customElements.define('product-bundle-item', ProductBundleItem);
  
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
  
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }
  
    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
  
    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
  
      this.hidePanel();
      this.elements.button.focus();
    }
  
    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }
  
    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  
    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  
  customElements.define('localization-form', LocalizationForm);
  
  // SPMSS-137 ===========================================||

  // Get all fieldset elements on the page
  var fieldsets = document.getElementsByTagName('fieldset');
  var button = document.getElementById('atcBtn');
  
  // Initialize an array to keep track of checked radios for each fieldset
  var checkedState = Array.from(fieldsets).map(() => false);
  
  // Function to check if all fieldsets have a checked radio button
  function checkAllFieldsets() {
      var allChecked = checkedState.every(state => state === true);
      button.disabled = !allChecked;
      return !allChecked;
  }
  
  // Iterate over each fieldset
  Array.from(fieldsets).forEach(function(fieldset, index) {
      var radios = fieldset.getElementsByTagName('input');
  
      Array.from(radios).forEach(function(radio) {
          if (radio.type === 'radio') {
              radio.addEventListener('change', function() {
                  checkedState[index] = true;
                  checkAllFieldsets();
              });
          }
      });
  });

  // SPMSS-137 ===========================================||
